export default __webpack_public_path__ + "static/media/Smiley_200x200_wbg2.11db406b.png";